<template>
  <div
    class="action-item favorite-btn"
    :class="{ 'is-favorited': favorited, 'is-loading': loading }"
    @click.prevent.stop="handleFavorite"
  >
    <svg
      class="action-icon fav-icon"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        :fill="favorited ? '#C00513' : 'none'"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>
    <span style="color: #999;">{{ favorited ? '已收藏' : '收藏' }}</span>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { favoriteNews } from '../../../api'

export default {
  name: 'FavoriteButton',
  props: {
    newsId: { type: [String, Number], default: '' },
    newsCode: { type: [String, Number], default: '' }
  },
  data() {
    return {
      favorited: false,
      loading: false
    }
  },
  mounted() {
    // 监听登录成功后的用户信息刷新
    console.log('[FavoriteButton] mounting, adding refresh-user-info listener')
    window.addEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  beforeDestroy() {
    console.log('[FavoriteButton] unmounting, removing event listeners')
    window.removeEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  methods: {
    async handleFavorite() {
      // eslint-disable-next-line no-console
      console.log('[FavoriteButton] click', { newsId: this.newsId, newsCode: this.newsCode })
      if (this.loading || (!this.newsId && !this.newsCode)) {
        // eslint-disable-next-line no-console
        console.log('[FavoriteButton] blocked', { loading: this.loading, newsId: this.newsId, newsCode: this.newsCode })
        return
      }
      const token = localStorage.getItem('token')
      if (!token) {
        // eslint-disable-next-line no-console
        console.log('[FavoriteButton] no token, trigger login event')
        // 触发全局登录事件 (由 PageHeader 管理登录弹窗)
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: window.location.pathname + window.location.search }
        })
        window.dispatchEvent(loginRequiredEvent)
        return
      }
      this.loading = true
      try {
        const status = this.favorited ? 0 : 1
        const params = this.newsId
          ? { newsId: this.newsId, status }
          : { newsCode: this.newsCode, status }
        // eslint-disable-next-line no-console
        console.log('[FavoriteButton] call favoriteNews', params)
        await favoriteNews(params)
        this.favorited = !this.favorited
        Toast(this.favorited ? '收藏成功' : '已取消收藏')
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('[FavoriteButton] error', e)
        const msg = e.message || '操作失败'
        if (msg.includes('已收藏')) {
          this.favorited = true
          Toast(msg)
        } else {
          Toast(msg)
        }
      } finally {
        this.loading = false
      }
    },
    handleRefreshUserInfo() {
      // 登录成功后不自动执行收藏操作
      console.log('[FavoriteButton] refresh-user-info event received, auto-favorite disabled')
    }
  }
}
</script>

<style scoped>
.favorite-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #999;
  transition: color 0.2s;
  user-select: none;
}

.favorite-btn:hover {
  color: #C00513;
}

.favorite-btn.is-favorited {
  color: #C00513;
}

.fav-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  object-fit: contain;
  transition: fill 0.2s;
}

.favorite-btn.is-loading {
  opacity: 0.6;
  pointer-events: none;
}
</style>
